export type PopoverPosition = 'top' | 'right' | 'bottom' | 'left'

export type PopoverAlign = 'begin' | 'center' | 'end'

export const getStyle = (classList: any[], styleObj: any) => {
  let classObj: Record<string, any> = {}
  classList.forEach((classname: any) => {
    classObj = Object.assign({}, classObj, searchStyleByClassName(classname, styleObj))
  })
  return classObj
}

const searchStyleByClassName = (classname: string, styleObj: { [x: string]: any }) => {
  let result = {}
  if (typeof styleObj === 'object') {
    Object.keys(styleObj).find((specname) => {
      if (specname === classname) {
        result = Object.assign({}, styleObj[specname])
        return true
      }
    })
  }
  return result
}

export const getWindowOffset = function (node: any) {
  let offsetLeft = 0
  let offsetTop = 0
  if (node.offsetParent) {
    do {
      offsetLeft += node.offsetLeft
      offsetTop += node.offsetTop
    } while ((node = node.offsetParent))
  }
  return {
    left: offsetLeft - window.scrollX,
    top: offsetTop - window.scrollY
  }
}
